import { render, staticRenderFns } from "./topic.vue?vue&type=template&id=1eab82a7&scoped=true&"
import script from "./topic.vue?vue&type=script&lang=js&"
export * from "./topic.vue?vue&type=script&lang=js&"
import style0 from "./topic.vue?vue&type=style&index=0&id=1eab82a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eab82a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eab82a7')) {
      api.createRecord('1eab82a7', component.options)
    } else {
      api.reload('1eab82a7', component.options)
    }
    module.hot.accept("./topic.vue?vue&type=template&id=1eab82a7&scoped=true&", function () {
      api.rerender('1eab82a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/topic.vue"
export default component.exports